import _get from 'lodash/get'
import _reduce from 'lodash/reduce'
import { fromJS } from 'immutable'
import {
  GET_SCREENS_DATA,
  GET_SCREEN_DATA,
  CREATE_SCREEN,
  UPDATE_SCREEN,
  setScreensProcessing,
  setScreensError,
  setScreensData,
  setScreen,
} from './actions'
import {
  getScreens,
  getScreen,
  createScreen,
  updateScreen,
} from '..'

const log = console

async function getScreensDataHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setScreensProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      language: payload,
    }
    let screens = await getScreens(options)
    screens = _get(screens, 'screens')

    const keyed = _reduce(screens, (obj, screen) => {
      obj[screen.id] = screen // eslint-disable-line no-param-reassign
      return obj
    }, {})

    const unsorted = fromJS(keyed)
    const sorted = unsorted.sortBy(
      (f) => f.get('screenType').toLowerCase(),
    )
    store.dispatch(setScreensData({
      data: sorted,
    }))
    store.dispatch(setScreensProcessing({ processing: false }))
  } catch (error) {
    log.error(error, 'Error getting screens')
    store.dispatch(setScreensError({
      error,
    }))
  }
}

async function getScreenDataHandler ({ store, payload }) {
  const { language, id } = payload
  const { config, auth } = store.getState()
  try {
    store.dispatch(setScreensProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      language,
      id,
    }
    const screen = await getScreen(options)

    store.dispatch(setScreen({
      data: fromJS(screen),
    }))
    store.dispatch(setScreensProcessing({ processing: false }))
  } catch (error) {
    log.error(error, 'Error getting screen')
    store.dispatch(setScreensError({
      error,
    }))
  }
}

async function createScreenHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setScreensProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      data: payload,
    }
    const results = await createScreen(options)
    if (results) {
      store.dispatch(setScreen({
        data: fromJS(results),
      }))
    }
    alert('Screen successfully created')
  } catch (error) {
    log.error(error, 'Error updating section')
    store.dispatch(setScreensError({
      error,
    }))
  }
}

async function updateScreenHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  const screenId = _get(payload, 'screenId')

  try {
    store.dispatch(setScreensProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      data: payload,
      screenId,
    }
    const results = await updateScreen(options)
    if (results) {
      store.dispatch(setScreen({
        data: fromJS(results),
      }))
    }
    alert('Screen successfully updated')
  } catch (error) {
    log.error(error, 'Error updating section')
    store.dispatch(setScreensError({
      error,
    }))
  }
}

export default (store) => (next) => (action) => {
  const { type, payload } = action
  switch (type) {
    case GET_SCREENS_DATA:
      getScreensDataHandler({ store, payload })
      break
    case GET_SCREEN_DATA:
      getScreenDataHandler({ store, payload })
      break
    case CREATE_SCREEN:
      createScreenHandler({ store, payload })
      break
    case UPDATE_SCREEN:
      updateScreenHandler({ store, payload })
      break
    default:
      break
  }
  next(action)
}
